export enum PARAMS {
  access = 'access',
  status = 'status',
  secondaryStatus = 'secondary-status',
}
